import { LeadFormValues } from "types/LeadForm"
import { createRemoteReducer, RemoteReducer } from "types/Remote"

export const configurationReducer: RemoteReducer<LeadFormValues> =
  createRemoteReducer("configuration")
